<template>
  <div id="vue-app">
    <router-view />
  </div>
</template>
